import { render, staticRenderFns } from "./ChangeCategoryPath.vue?vue&type=template&id=0323bb8b&scoped=true&"
import script from "./ChangeCategoryPath.vue?vue&type=script&lang=js&"
export * from "./ChangeCategoryPath.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCategoryPath.vue?vue&type=style&index=0&id=0323bb8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0323bb8b",
  null
  
)

export default component.exports